import type { ConversationSummaryT } from '../data/api.js';

export type ProjectChatSortField = 'created' | 'updated';
export type ProjectChatSortDirection = 'asc' | 'desc';

/** Stable project-chat ordering used by the sidebar's creation/update controls. */
export function sortProjectChats(
  chats: readonly ConversationSummaryT[],
  field: ProjectChatSortField,
  direction: ProjectChatSortDirection,
): ConversationSummaryT[] {
  const key = field === 'created' ? 'createdAt' : 'updatedAt';
  const sign = direction === 'asc' ? 1 : -1;
  return chats
    .map((chat, index) => ({ chat, index }))
    .sort((a, b) => {
      const byTime = new Date(a.chat[key]).getTime() - new Date(b.chat[key]).getTime();
      return byTime === 0 ? a.index - b.index : byTime * sign;
    })
    .map(({ chat }) => chat);
}
